import * as React from 'react';

import { ExtraVillage } from './ExtraVillage';
import styles from './ExtraVillages.css';
import { trackSimilarVillageClick, trackSimilarVillagesShow } from './tracking';
import { EExtraVillages, EXTRA_VILLAGES_TITLE_MAP } from '../../constants/village';
import { TUser, MODERATION_STATUS_TYPES, IGetVillageResponseSchema } from '../../types';
import { getHighway, isArrayWithItems } from '../../utils/helpers';

export interface IExtraVillagesStoreProps {
  abGroup: number;
  regionHasRoads: boolean;
  user: TUser | undefined;
  villageData: IGetVillageResponseSchema;
}

export interface IExtraVillagesOwnProps {
  type: EExtraVillages;
}

export type TExtraVillagesProps = IExtraVillagesStoreProps & IExtraVillagesOwnProps;

export class ExtraVillages extends React.Component<TExtraVillagesProps> {
  public componentDidMount() {
    const villages = this.getVillages();
    if (villages) {
      trackSimilarVillagesShow(this.props.villageData, this.props.user, this.props.abGroup, villages, this.props.type);
    }
  }

  public render() {
    const {
      regionHasRoads,
      villageData: {
        village: { builder, regionId },
      },
    } = this.props;
    const villages = this.getVillages();
    if (!villages || !builder || !isArrayWithItems(villages) || (this.isSimilar() && !this.shouldBuilderRender())) {
      return null;
    }

    return (
      <div className={styles['container']}>
        <div className={styles['title']}>{this.title}</div>
        <ul className={styles['list']}>
          {villages.map((village, index) => (
            <ExtraVillage
              key={village.id}
              village={village}
              regionId={regionId}
              highway={(regionHasRoads && getHighway(village.roadInfoList)) || null}
              onVillageLinkClick={this.onVillageLinkClick(village.id, index)}
            />
          ))}
        </ul>
      </div>
    );
  }

  private getVillages() {
    const {
      villageData: { nearbyVillages, similarVillages },
    } = this.props;

    return this.isSimilar() ? similarVillages : nearbyVillages;
  }

  private get builder() {
    return this.props.villageData.village.builder;
  }

  private get title(): string {
    const builderName = this.builder?.name ? ` «${this.builder?.name}»` : '';

    return this.isSimilar()
      ? `Похожие коттеджные посёлки застройщика${builderName}`
      : EXTRA_VILLAGES_TITLE_MAP[EExtraVillages.Nearby];
  }

  public shouldBuilderRender = () => this.builder?.moderationStatus === MODERATION_STATUS_TYPES.Published;

  private isSimilar = () => this.props.type === EExtraVillages.Similar;

  private onVillageLinkClick = (villageId: number, index: number) => () =>
    trackSimilarVillageClick(
      this.props.villageData,
      this.props.user,
      this.props.abGroup,
      villageId,
      index + 1,
      this.props.type,
    );
}
